import { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useNavigate } from "react-router-dom";
import api from '../api/api'
import Loading from "../components/loading";
import ModalErrorMessage from "../components/modalErrorMessage/modalErrorMessage";

function DentistModal({ open, onClose, onSave, dentist: selectedDentist }) {
    const [name, setName] = useState('');
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');


    useEffect(() => {
        if (selectedDentist) {
            setName(selectedDentist.nome);
        }
    }, [selectedDentist, open]);

    const saveDentist = () => {
        if (!name.trim()) {
            setShowErrorMessage(true);
            setErrorMessage('Inserir um nome é obrigatório.');
            return;
        }

        const isEditing = !!selectedDentist?.id;

        setLoading(true);
        if (isEditing) {
            api.put('/dentista', { id: selectedDentist.id, nome: name }, {
                headers: {
                    Authorization: sessionStorage.getItem('token')
                }
            })
            .then(returnFromApi => {
                setLoading(false);
                onClose();
                onSave(returnFromApi);
            })
            .catch((returnFromApi) => {
                setLoading(false);
                console.error("ops! ocorreu um erro" + returnFromApi);
                setErrorMessage(returnFromApi.response.data);
                if (returnFromApi.status === 401) {
                    navigate("/expired-session");
                }
            });
        } else {
            api.post('/dentista', { nome: name }, {
                headers: {
                    Authorization: sessionStorage.getItem('token')
                }
            })
            .then(returnFromApi => {
                setLoading(false);
                cleanFields();
                onClose();
                onSave(returnFromApi);
            })
            .catch((returnFromApi) => {
                setLoading(false);
                console.error("ops! ocorreu um erro" + returnFromApi);
                setErrorMessage(returnFromApi.response.data);
                if (returnFromApi.status === 401) {
                    navigate("/expired-session");
                }        
            });
        }
    };

    function cleanFields() {
        setName('');
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ fontWeight: 'bold' }}>Cadastrar Novo Dentista</DialogTitle>
            <DialogContent>
                <Loading isToHidden={isLoading === false} />
                {showErrorMessage && <ModalErrorMessage message={errorMessage} setShow={setShowErrorMessage} />}

                <TextField id="name" label="Nome do dentista *" type="text" fullWidth value={name}
                    onChange={(e) => setName(e.target.value)}
                    sx={{ mt: 2 }}
                />
            </DialogContent>
            <DialogActions sx={{ p: '0 24px 16px' }}>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={saveDentist} variant="contained">Salvar</Button>
            </DialogActions>
        </Dialog>
    );
}
export default DentistModal;